module.exports = __webpack_public_path__ + "assets/img/520c5112c8770abc518bc54b69ff384a.svg";